// extracted by mini-css-extract-plugin
export default {"step_container":"ItemStep_step_container__o0QCR","title_container":"ItemStep_title_container__JMRij"};